import { LOG_OUT_REGISTRANT_SUCCESS, UPDATE_USER_SESSION } from './registrantLogin/actionTypes';
import { getIn } from 'icepick';
import querystring from 'querystring';
import { getQueryParam } from '../utils/queryUtils';

const defaultUserSession = {
  isPlanner: false,
  isPreview: false,
  isTestMode: false,
  showEventBuildWizardBanner: false,
  eventBuildWizardExitUrl: '',
  licenseTypeId: 1,
  isFreeTrial: false,
  freeTrialPurchaseCta: '',
  scrollToRegTyoe: false
};

const reducer = (state = defaultUserSession, action) => {
  switch (action.type) {
    case LOG_OUT_REGISTRANT_SUCCESS:
      return {
        // clears registrant information, including: regCartId, inviteeId, contactId, referenceId, emailAddress...
        eventId: state.eventId,
        isPreview: state.isPreview,
        isPlanner: state.isPlanner,
        isTestMode: state.isTestMode,
        showEventBuildWizardBanner: state.showEventBuildWizardBanner,
        eventBuildWizardExitUrl: state.eventBuildWizardExitUrl,
        licenseTypeId: state.licenseTypeId,
        isFreeTrial: state.isFreeTrial,
        freeTrialPurchaseCta: state.freeTrialPurchaseCta,
        scrollToRegType: state.scrollToRegTyoe,
        httpReferrer: state.httpReferrer
      };
    case UPDATE_USER_SESSION:
      return action.payload;
    default:
      return state;
  }
};

export const getInitialRegistrationTypeId = (state) => {
  return getIn(state, ['userSession', 'defaultRegTypeId'])
    || '00000000-0000-0000-0000-000000000000';
};

export const getRegistrationPackId = (state) => {
  return getIn(state, ['userSession', 'defaultRegPackId']);
};

export const isPlannerRegMod = (state) => {
  return getIn(state, ['userSession', 'isPlannerRegMod']) === true;
};

export function isPlannerRegistration(state) {
  return !!state.userSession.isPlanner;
}

export function isLinkedInviteeRegistration(state) {
  return !!state.userSession.inviteeId;
}

export async function setQueryParamsInUserSession(dispatch, state) {
  const queryParams = window && window.location && querystring.parse(window.location.search.slice(1));
  await dispatch({
    type: UPDATE_USER_SESSION,
    payload: ({
      ...state.userSession,
      defaultRegPackId: queryParams.registrationPackId || undefined,
      referenceId: getQueryParam(queryParams, 'refid')
    })
  });
}

export async function toggleScrollToRegType(dispatch, state) {
  await dispatch({
    type: UPDATE_USER_SESSION,
    payload: ({
      ...state.userSession,
      scrollToRegType: !state.userSession.scrollToRegTyoe
    })
  });
}

export default reducer;
